import { mapCinemaGuideTabs } from './cinemaGuideTabs'
import { mapCinemaFeatures } from './cinemaFeatures'
import { mapCinemaExperienceSlides } from './cinemaExperienceSlides'
import { mapRegionalAnnouncement } from './regionalAnnouncement'

export interface ExtensionDef {
    name: string
    mapper: (data, attrData) => any
    mapAttributes?: string
}

export class Extensions {
    CinemaFeature: ExtensionDef = { name: 'cinemaFeature', mapper: mapCinemaFeatures, mapAttributes: 'attributes' }
    CinemaGuideTabs: ExtensionDef = { name: 'cinema/guideTabs', mapper: mapCinemaGuideTabs }
    CinemaExperienceSlides: ExtensionDef = { name: 'cinema/experienceSlides', mapper: mapCinemaExperienceSlides }
    RegionalAnnouncement: ExtensionDef = { name: 'cinema/regionalannouncement', mapper: mapRegionalAnnouncement }
}

export const extensions = new Extensions()
